// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9eN9w","breadcrumbs":"styles_breadcrumbs__NHvv3","link":"styles_link__Awikw","separator":"styles_separator__DEoff"};